import { render, staticRenderFns } from "./CoinRewardRule.vue?vue&type=template&id=013f4962"
import script from "./CoinRewardRule.vue?vue&type=script&lang=ts"
export * from "./CoinRewardRule.vue?vue&type=script&lang=ts"
import style0 from "./CoinRewardRule.vue?vue&type=style&index=0&id=013f4962&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports